// extracted by mini-css-extract-plugin
module.exports = {"content":"adsveritising_content__sXcNf","text":"adsveritising_text__tJIY2","advertising":"adsveritising_advertising__WYQnE"};